<template>
  <div class="mx-auto max-w-xl py-2">
    <div class="breadcrumbs mb-2">
      <NuxtLink :to="{ name: 'games' }">{{ $t('shared.nav.fixtures') }}</NuxtLink>
    </div>
    <h1 class="font-heading font-bold text-2xl" v-html="$t('shared.nav.fixtures')" />
    <div class="grid gap-4 mt-4" v-auto-animate>
      <div class="grid gap-1" v-if="fixtures?.length">
        <!-- <div class="font-bold">{{ $t('shared.nav.fixtures') }}</div> -->
        <PartialsGames :games="fixtures" />
      </div>
      <div class="grid gap-1" v-if="results?.length">
        <div class="font-bold">{{ $t('shared.nav.results') }}</div>
        <PartialsGames :games="results" />
      </div>
    </div>
  </div>
</template>

<script setup>
const { data } = useFetch(`/api/v1/games`, { 
  key: `games`,
  baseURL: useEnv('apiBase'),
  query: {
    fromDate: useDate().subtract(30, 'day').format('YYYY-MM-DD'),
    untilDate: useDate().add(30, 'day').format('YYYY-MM-DD'),
  }
})

const now = useDate()

// 1. Fixtures: Games from the last 7 days (based on first game date)
const fixtures = computed(() => {
  const upcomingGames = data.value?.games?.filter(g => !now.isAfter(g.startDate)) || []
  const upcomingDate = upcomingGames[0]?.startDate
  const weekBeforeLatest = useDate(upcomingDate).add(6, 'day')

  return upcomingGames
    ?.filter(g => weekBeforeLatest.isAfter(g.startDate))
})

// 2. Results: Games from the last 7 days (based on last game date)
const results = computed(() => {
  const pastGames = (data.value?.games?.filter(g => now.isAfter(g.startDate)) || [])?.reverse()
  const latestDate = pastGames[0]?.startDate
  const weekBeforeLatest = useDate(latestDate).subtract(6, 'day')

  return pastGames
    ?.filter(g => useDate(g.startDate).isSameOrAfter(weekBeforeLatest))
})
</script>